// Shared constants for AI Avatar Page
import {ScriptConfiguration, ScriptStyle} from '@contentlab/api/avatars';

export const WORD_COUNT_TOLERANCE = 0.3;

// AI Avatar page constants
export const AI_AVATAR_CONSTANTS = {
  EMPTY_VIDEO_URL:
    'https://storage.googleapis.com/brands-public-assets/content-lab/ai-avatar-empty-state.mp4',
} as const;

export const PREVIEW_AVATAR_POSITION_CORRECTION = '0% 15%';

export const DEFAULT_SCRIPT_CONFIG: ScriptConfiguration = {
  scriptStyle: ScriptStyle.Neutral,
  product: null,
  callToAction: null,
  targetPlatform: null,
  targetAudience: null,
  tone: null,
  scriptType: null,
  specialRequests: null,
};
